import Plyr from '../../../assets/custom_components/plyr/plyr'

/* @ngInject */
function AssetPreviewAudioController ($rootScope, $scope, AssetPreviewService, $attrs, SegmentService) {
  const controls = [
    'progress',
    'play',
    'restart',
    'mute',
    'volume',
    'current-time',
    'duration',
    'settings',
    'speed'
  ]

  const settings = [
    'speed'
  ]

  const api = {
    _getAudioPreview
  }
  this.getApi = () => api

  activate()
  function activate () {
    api._getAudioPreview($scope.template)
  }

  const deregisterReloadPreview = $rootScope.$on('asset-preview-dialog.reload-preview-details', () => {
    // remove old player
    $scope.player.destroy()

    // set audio source
    api._getAudioPreview($scope.template)

    // reinitialize player and play automatically
    $scope.initilizePlyr()
    $scope.player.play()
  })

  $scope.$on('$destroy', () => {
    deregisterReloadPreview()
  })

  $scope.initilizePlyr = function () {
    const playerElement = $attrs.$$element.find('[data-preview="audio"]')[0]
    const player = new Plyr(playerElement, { controls, settings })
    $scope.player = player

    player.source = {
      type: 'audio',
      sources: [
        {
          src: $scope.audioUrl,
          type: 'audio/mp3'
        }
      ]
    }

    player.on('pause', () => {
      SegmentService.track('arts-preview-interact', { interact_type: 'stop', type: 'upload' })
    })

    player.on('playing', () => {
      SegmentService.track('arts-preview-interact', { interact_type: 'play', type: 'upload' })
    })
  }

  function _getAudioPreview (file) {
    if (file.isTemplate) {
      $scope.audioUrl = AssetPreviewService.getArtPreview(file.id)
    } else {
      const moduleLocation = AssetPreviewService.getModuleForLocation($scope.location)
      $scope.audioUrl = AssetPreviewService.getAssetPreview(file.id, moduleLocation)
    }
  }
}

export { AssetPreviewAudioController }
